module.exports = __webpack_public_path__ + "static/starelephanthamper-6a9f8800eadd627dfed3dd615b71b3df.jpeg";